import React, { Component } from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';
import * as firebase from 'firebase';
import Routes from './routes';
import LoadingState from './components/Loading';

class App extends Component {

  _maybeHaveUser(){
    return (this.props.user.loading === false && this.props.user.status !== null)
  }

  componentDidMount() {
    this.props.getAuthUser();
    document.addEventListener('DOMContentLoaded', function() {
      firebase.auth().onAuthStateChanged(user => console.log(user) );
    });
  }

  render() {
    return (
      <div>
        {this.props.user.loading &&  <LoadingState/>}
        {this._maybeHaveUser() && <Routes isAuthenticated={(this.props.user.status === 'authenticated')}/>}
      </div>
    );
  }
}

export default muiThemeable()(App);



// WEBPACK FOOTER //
// ./src/App.js